import { render } from "./UpdateOnlyPayment.vue?vue&type=template&id=1fc0edd8&scoped=true"
import script from "./UpdateOnlyPayment.vue?vue&type=script&lang=js"
export * from "./UpdateOnlyPayment.vue?vue&type=script&lang=js"

import "./UpdateOnlyPayment.vue?vue&type=style&index=0&id=1fc0edd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc0edd8"]])

export default __exports__